import show from './show'
import load from './load'
import { close, get, patch } from './modalManager'

/**
 * Central service to define, load, show and close modals.
 */
export default { show, load, close, get, patch }
